"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1: function() {
        return _index.Caption1;
    },
    caption1ClassNames: function() {
        return _index.caption1ClassNames;
    }
});
const _index = require("./components/presets/Caption1/index");
